import angular, { Injectable, IPromise, IRequestConfig } from "angular";
import { IFieldArray } from "AngularFormly";
import { Record } from "../../server/crud";
import { IHasResponseStatus } from "../../server/query";
import { ServerUtility } from "../../server/serverUtility";
import { FormSubmitArgs, FormViewController } from "./controller";

export const vsServiceName = "formViewService";
export const vsName = vsServiceName;

export interface SubmitFormConfig extends SaveFormConfig {
  method: string;
}

export interface SaveFormConfig {
  url: string;
  formObject: unknown;
  formViewController: FormViewController;
  validationPrefix?: string;
}

export interface FormViewServiceFormFactory {
  (...args: any[]): FormViewConfig;
}

/**
 * @argument submitForm - an injectable that constructs an injectable.  The inner injectable is due to an & binding and can inject model and formViewController
 */
export interface FormViewConfig {
  name: string;
  fields: IFieldArray;
  title: (model: any) => string;
  submitForm: (args: FormSubmitArgs) => IPromise<any>;
}

export class FormViewService {
  constructor(
    private readonly configs: {
      [name: string]: Injectable<FormViewServiceFormFactory> | undefined;
    },
    private readonly serverUtility: ServerUtility,
    private readonly $injector: angular.auto.IInjectorService
  ) { }

  getFormViewConfig(
    name: string,
    config?: FormViewConfig
  ): FormViewConfig | undefined {
    const configFactory = this.configs[name];
    if (configFactory === undefined) return undefined;

    const defaultConfig = this.$injector.invoke(configFactory);

    return {
      ...defaultConfig,
      ...config,
    };
  }

  saveForm(config: SaveFormConfig) {
    const id = (<Record>config.formObject)?.Id;
    const newItem = id === undefined || id === 0;
    const method = newItem ? "POST" : "PUT";
    const url = newItem ? config.url : `${config.url}/${id}`;

    return this.submitForm({
      formObject: config.formObject,
      formViewController: config.formViewController,
      method,
      url,
      validationPrefix: config.validationPrefix,
    });
  }

  submitForm<T>(config: SubmitFormConfig) {
    const requestConfig: IRequestConfig = {
      method: config.method,
      url: config.url,
      data: config.formObject,
    };

    return this.serverUtility
      .sendApiRequest<T>(requestConfig)
      .catch((error) => {
        const apiResponse = <IHasResponseStatus>error.data;
        config.formViewController.setApiErrors(
          apiResponse.ResponseStatus,
          config.validationPrefix
        );

        throw error;
      });
  }
}
